import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl, ipAddress, userName} from '../Univ';
function OwnerAssignments() {
    const userId = localStorage.getItem("user_id");
    const [ownerId, setOwnerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [requirements, setRequirements] = useState([]);
    const [selectedReq, setSelectedReq] = useState(null); // requirement clicked
    const [applications, setApplications] = useState([]);
    const [showWorkersModal, setShowWorkersModal] = useState(false);
    // ---------------- FETCH REQUIREMENTS ----------------
    useEffect(() => {
        axios.get(baseUrl + "landowner-profile/" + userId + "/")
            .then((res) => {
                console.log("Response:", res.data);
                if (res.data.length > 0) {
                    setOwnerId(res.data[0].id);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = () => {
        setLoading(true);
        axios.get(baseUrl + "landowner-req/")
            .then(res => {
                setRequirements(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };
    // ---------------- FETCH APPLICATIONS FOR A REQUIREMENT ----------------
// ---------------- FETCH APPLICATIONS FOR A REQUIREMENT ----------------
    const fetchApplications = async (reqId) => {
        try {
            const res = await axios.get(baseUrl + "apply/");
            // Filter by requirement and only those not yet approved
            const applied = res.data
                .filter(a => a.requirement.id === reqId && a.owner_app === 0);
            setApplications(applied);
        } catch (err) {
            console.log(err);
        }
    };
    // ---------------- SELECT REQUIREMENT ----------------
    const handleReqClick = async (req) => {
        setSelectedReq(req);
        try {
            const res = await axios.get(
                baseUrl + "apply/"
            );
            const applied = res.data.filter(
                a =>
                    a.requirement.id === req.id &&
                    a.owner_app === 0
            );
            setApplications(applied);
            // Open modal
            setShowWorkersModal(true);
        } catch (err) {
            console.log(err);
        }
    };
    // ---------------- APPROVE WORKER ----------------
    const handleApprove = async (app) => {
        try {
            // Step 1: Approve application
            const fd = new FormData();
            fd.append("owner_app", "1");
            await axios.patch(
                `${baseUrl}apply-status/${app.id}/`,
                fd
            );
            // Step 2: Create Assignment
            const assignFd = new FormData();
            assignFd.append(
                "requirement",
                app.requirement.id
            );
            assignFd.append(
                "worker",
                app.worker.id
            );
            assignFd.append(
                "owner_approved",
                true
            );
            assignFd.append(
                "start_date",
                new Date().toISOString().split("T")[0]
            );
            assignFd.append(
                "status",
                "ACTIVE"
            );
            assignFd.append(
                "total_present_days",
                0
            );
            assignFd.append(
                "total_amount",
                0
            );
            assignFd.append(
                "addedby",
                userName
            );
            assignFd.append(
                "ip_add",
                ipAddress
            );
            await axios.post(
                baseUrl + "assignment/",
                assignFd
            );
            Swal.fire(
                "Success",
                "Worker Approved & Task Assigned",
                "success"
            );
            fetchApplications(selectedReq.id);
        } catch (err) {
            console.log(err.response?.data);
            Swal.fire(
                "Error",
                "Something went wrong",
                "error"
            );
        }
    };
    return (
        <section className="container mt-4">

            <div className="page-header">
                <h3>Owner Tasks</h3>
                <small>
                    Manage requirements and approve workers
                </small>
            </div>

            <div className="row">

                {requirements.length === 0 && (
                    <div className="alert alert-warning">
                        No Requirements Posted Yet
                    </div>
                )}

                {requirements.map((req) => (
                    <div
                        key={req.id}
                        className="col-lg-3 col-md-4 col-sm-6 mb-4"
                    >

                        <div
                            className="card app-card"
                            style={{
                                cursor:
                                    req.status === 0
                                        ? "not-allowed"
                                        : "pointer"
                            }}
                            onClick={() =>
                                req.status !== 0 &&
                                handleReqClick(req)
                            }
                        >

                            <div className="app-card-header">

                                🌱 {req.crop_type}

                            </div>

                            <div className="app-card-body">

                                <p>
                                    <strong>Land:</strong>
                                    {" "}
                                    {req.land_size}
                                    {" "}
                                    {req.land_unit}
                                </p>

                                <p>
                                    <strong>Location:</strong>
                                    {" "}
                                    {req.location}
                                </p>

                                <p>
                                    <strong>Pincode:</strong>
                                    {" "}
                                    {req.pincode}
                                </p>

                                <p>
                                    <strong>Budget:</strong>
                                    {" "}
                                    ₹{req.budget}
                                </p>

                                <p>
                                    <strong>Date:</strong>
                                    {" "}
                                    {req.required_date}
                                </p>

                            </div>

                            <div className="app-card-footer">

                                {req.status === 0 ? (
                                    <button
                                        className="btn btn-secondary w-100"
                                        disabled
                                    >
                                        ✅ Completed
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-warning w-100 fw-bold"
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            try {
                                                await axios.patch(
                                                    `${baseUrl}update-requirements/${req.id}/`,
                                                    {
                                                        status: 0
                                                    }
                                                );
                                                Swal.fire(
                                                    "Success",
                                                    "Requirement marked as completed",
                                                    "success"
                                                );
                                                setRequirements(prev =>
                                                    prev.map(r =>
                                                        r.id === req.id
                                                            ? {
                                                                ...r,
                                                                status: 0
                                                            }
                                                            : r
                                                    )
                                                );
                                            } catch (err) {
                                                console.log(
                                                    err.response?.data
                                                );
                                                Swal.fire(
                                                    "Error",
                                                    "Something went wrong",
                                                    "error"
                                                );
                                            }
                                        }}
                                    >
                                        Work Complete
                                    </button>
                                )}

                            </div>

                        </div>

                    </div>
                ))}

            </div>

            {/* WORKERS MODAL */}

            {showWorkersModal && (
                <div
                    className="modal fade show app-modal"
                    style={{
                        display: "block",
                        backgroundColor:
                            "rgba(0,0,0,.5)"
                    }}
                >

                    <div
                        className="modal-dialog modal-xl modal-dialog-centered"
                    >

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">

                                    Workers Applied For :
                                    {" "}
                                    {selectedReq?.crop_type}

                                </h5>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() =>
                                        setShowWorkersModal(false)
                                    }
                                />

                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto"
                                }}
                            >

                                {applications.length === 0 && (
                                    <div className="alert alert-warning">

                                        No New Workers Applied Yet

                                    </div>
                                )}

                                <div className="row">

                                    {applications.map((app) => (
                                        <div
                                            key={app.id}
                                            className="col-lg-4 col-md-6 mb-4"
                                        >

                                            <div className="card app-card">

                                                <div
                                                    className="app-card-header"
                                                >

                                                    👨‍🌾
                                                    {" "}
                                                    {app.worker.name}

                                                </div>

                                                <div
                                                    className="app-card-body"
                                                >

                                                    <p>
                                                        <strong>
                                                            Cost:
                                                        </strong>
                                                        {" "}
                                                        ₹
                                                        {app.worker.cost}
                                                        {" "}
                                                        /
                                                        {" "}
                                                        {app.worker.unit}
                                                    </p>

                                                    <p>
                                                        <strong>
                                                            Work Type:
                                                        </strong>
                                                        {" "}
                                                        {app.worker.work_type}
                                                    </p>

                                                    <p>
                                                        <strong>
                                                            Mobile:
                                                        </strong>
                                                        {" "}
                                                        {app.worker.mobile}
                                                    </p>

                                                    <p>
                                                        <strong>
                                                            Pincode:
                                                        </strong>
                                                        {" "}
                                                        {app.worker.pincode}
                                                    </p>

                                                    <span
                                                        className="badge bg-warning text-dark"
                                                    >
                        Pending
                      </span>

                                                </div>

                                                <div
                                                    className="app-card-footer"
                                                >

                                                    <button
                                                        className="btn btn-success-action w-100"
                                                        onClick={() =>
                                                            handleApprove(app)
                                                        }
                                                    >
                                                        ✅ Approve Worker
                                                    </button>

                                                </div>

                                            </div>

                                        </div>
                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </section>
    );
}
export default OwnerAssignments;
